/*
  Scroll snapping gives way to content.

  The page snaps from one screen to the next, which works while every
  section fits the screen. A section that does not would be a trap
  under `mandatory`: the reader could never rest on its lower part,
  because the browser would always pull back to a snap point.

  Dropping only the tall sections out of the chain is worse: on a
  phone most sections are taller than the screen, the few snap points
  left are thousands of pixels apart, and one flick yanks the page
  from the hero to whichever section still fits. So once any section
  outgrows the window the whole page loosens to `proximity`: every
  section keeps its snap point, the page settles on one only when a
  scroll ends near it, and anywhere in between is a place to rest.
*/
(function () {
  var sections;

  function check() {
    if (!sections) return;
    var vh = window.innerHeight;

    var loose = sections.some(function (el) {
      return el.getBoundingClientRect().height > vh + 1;
    });
    document.documentElement.toggleAttribute('data-sh-snap-loose', loose);
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    if (!sections.length) return;

    check();
    window.addEventListener('resize', check, { passive: true });
    window.addEventListener('load', check);

    // Sections size themselves from the viewport and from images that
    // arrive late, so their height is not settled at first paint.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(check);
      sections.forEach(function (el) { ro.observe(el); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', check);
})();
